module.exports = __webpack_public_path__ + "img/NR.b9331e8e.svg";